"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Int64MinValue = exports.Int64MaxValue = exports.Int32MinValue = exports.Int32MaxValue = exports.Int16MinValue = exports.Int16MaxValue = exports.ERROR_TYPES = exports.ERROR_INTERNAL_SERVER_ERROR = exports.ERROR_UNAUTHORIZED = exports.ERROR_PRECONDITION_FAILED = exports.ERROR_NOT_FOUND = exports.ERROR_FORBIDDEN = exports.ERROR_BAD_REQUEST = exports.INPUT_TYPES = void 0;
// input types
var INPUT_TYPES = ['text', 'number', 'tel', 'email', 'password']; // error types

exports.INPUT_TYPES = INPUT_TYPES;
var ERROR_BAD_REQUEST = 'MHUB:BAD_REQUEST';
exports.ERROR_BAD_REQUEST = ERROR_BAD_REQUEST;
var ERROR_FORBIDDEN = 'MHUB:FORBIDDEN';
exports.ERROR_FORBIDDEN = ERROR_FORBIDDEN;
var ERROR_NOT_FOUND = 'MHUB:NOT_FOUND';
exports.ERROR_NOT_FOUND = ERROR_NOT_FOUND;
var ERROR_PRECONDITION_FAILED = 'MHUB:PRECONDITION_FAILED';
exports.ERROR_PRECONDITION_FAILED = ERROR_PRECONDITION_FAILED;
var ERROR_UNAUTHORIZED = 'MHUB:UNAUTHORIZED';
exports.ERROR_UNAUTHORIZED = ERROR_UNAUTHORIZED;
var ERROR_INTERNAL_SERVER_ERROR = 'MHUB:INTERNAL_SERVER_ERROR';
exports.ERROR_INTERNAL_SERVER_ERROR = ERROR_INTERNAL_SERVER_ERROR;
var ERROR_TYPES = [ERROR_BAD_REQUEST, ERROR_FORBIDDEN, ERROR_NOT_FOUND, ERROR_PRECONDITION_FAILED, ERROR_UNAUTHORIZED, ERROR_INTERNAL_SERVER_ERROR];
exports.ERROR_TYPES = ERROR_TYPES;
var Int16MaxValue = 32767;
exports.Int16MaxValue = Int16MaxValue;
var Int16MinValue = Int16MaxValue + 1;
exports.Int16MinValue = Int16MinValue;
var Int32MaxValue = 2147483647;
exports.Int32MaxValue = Int32MaxValue;
var Int32MinValue = Int32MaxValue + 1;
exports.Int32MinValue = Int32MinValue;
var Int64MaxValue = 9223372036854775807;
exports.Int64MaxValue = Int64MaxValue;
var Int64MinValue = Int64MaxValue + 1;
exports.Int64MinValue = Int64MinValue;